import React from 'react';
import PropTypes from 'prop-types';
import { getUser } from 'src/utils/Common';
import { Typography, Grid } from '@mui/material';
import {text} from "src/modules/languages/index"
const styles = {
  root: {},
  summaryButton: (theme) => ({
    backgroundColor: theme.palette.common.white
  }),
  barChartIcon: (theme) => ({
    marginRight: theme.spacing(1)
  }),
  image: {
    width: '100%',
    maxHeight: 400
  }
};

function Header({ className, ...rest }) {
  const SessionUser = getUser();
  return (
    <div  {...rest} className={className} style={styles.root}>
      <Grid
        alignItems="center"
        container
        justifyContent="space-between"
        spacing={3}
      >
        <Grid
          size={{
            md: 6,
            xs: 12
          }}>
          <Typography
            component="h1"
            gutterBottom
            variant="h3"
          >
            {text("iyi_gunler")},
            {' '}
            {SessionUser.FirstName} {SessionUser.LastName}
          </Typography>
          <Typography
            gutterBottom
            variant="subtitle1"
          >
            {"İşlemleriniz Aşağıdaki Gibidir!..."}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
